/* eslint-disable react/prop-types */
import React, { Fragment } from 'react';
import { Row, Col } from 'react-flexbox-grid';

import Link from '../../../common/components/Link';
import idSafe from '../../../../assets/images/seal-id-safe.png';
import kidSafe from '../../../../assets/images/seal-kid-safe.png';
import PaperHeader from '../../components/PaperHeader';

import { Disclaimer, Icon, IconContainer, CenteredRow } from './styled-components';

const AuthFlow = ({ title, children }) => (
  <Fragment>
    <CenteredRow>
      <PaperHeader title={title} />
    </CenteredRow>
    {children}
    <Row center="xs">
      <Col xs={12}>
        <IconContainer>
          <a
            href="https://stacksports.com/legal-privacy/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Icon src={idSafe} alt="ID Safe Badge" />
          </a>
          <a href="https://stacksports.com/legal-COPPA/" target="_blank" rel="noopener noreferrer">
            <Icon src={kidSafe} alt="Kid Safe Badge" />
          </a>
        </IconContainer>
      </Col>
    </Row>
    <Row center="xs">
      <Col xs={12}>
        <Disclaimer>
          By signing in, you agree to our <Link to="/tos">ToS</Link> and
          <Link to="/privacy-policy"> Privacy Policy</Link>
        </Disclaimer>
      </Col>
    </Row>
  </Fragment>
);

export default AuthFlow;



// WEBPACK FOOTER //
// ./src/views/sports-connect/layouts/AuthFlow/index.js